import { Card, CardHeader, MarkdownContent } from '@/components/ui';
import { Sparkles } from 'lucide-react';

interface McpQuickSetupPanelProps {
  markdown: string | undefined;
  /** Copyable inline-code values (typically the OAuth callback URL). */
  copyableValues?: string[];
}

/**
 * Prominent walkthrough for MCP providers that ship a focused onboarding
 * guide. Returns null when the provider has no quick markdown so non-opted-in
 * providers see no empty card.
 */
export default function McpQuickSetupPanel({
  markdown,
  copyableValues,
}: McpQuickSetupPanelProps) {
  if (!markdown) return null;
  return (
    <Card className="ring-1 ring-primary-200 dark:ring-primary-900/40">
      <CardHeader
        title="Quick setup"
        description="Get your MCP server connected."
        action={
          <Sparkles className="h-5 w-5 text-primary-500" aria-hidden="true" />
        }
      />
      <MarkdownContent size="sm" copyableValues={copyableValues}>
        {markdown}
      </MarkdownContent>
    </Card>
  );
}
